import { DomainError } from "@econ-v1/domain";
import { DISCOVERY_PROBE_COMMAND, DISCOVERY_PROMOTE_COMMAND, isProbeCandidatesPayload, isPromoteCandidatePayload, } from "@econ-v1/rpc";
/**
 * The kernel side of the #1815 interim "search the node on the LAN" seam
 * (`client/rpc/src/onboarding/discovery-contract.ts`). Delegates entirely to
 * `DiscoveryProbeService` — the probe, the fail-closed identity proof, and the promotion
 * guard all live there; this class is wiring: payload validation + command-name routing,
 * the same shape as `SettingsCommandDispatcher`.
 *
 * `probe-candidates` awaits the full probe cycle and returns the final snapshot, but
 * `DiscoveryProbeService.onChange` fires (and, wired in the composition root, publishes a
 * `domain.entity-changed` event) after *every* per-candidate transition — so a caller
 * subscribed to the `onboarding.discovery.v1` live query sees each status change as it
 * happens, not just the final result this command resolves with.
 */
export class DiscoveryCommandDispatcher {
    service;
    next;
    constructor(service, next) {
        this.service = service;
        this.next = next;
    }
    async execute(name, payload) {
        switch (name) {
            case DISCOVERY_PROBE_COMMAND: {
                if (!isProbeCandidatesPayload(payload)) {
                    throw new DomainError({ code: "invalid_request", message: "Invalid probe-candidates payload" });
                }
                const rows = await this.service.probe(payload.addresses);
                return JSON.parse(JSON.stringify(rows));
            }
            case DISCOVERY_PROMOTE_COMMAND: {
                if (!isPromoteCandidatePayload(payload)) {
                    throw new DomainError({ code: "invalid_request", message: "Invalid promote-candidate payload" });
                }
                await this.service.promote(payload.address);
                return { promoted: true };
            }
            default:
                if (this.next !== undefined)
                    return await this.next.execute(name, payload);
                throw new DomainError({ code: "not_found", message: "Host command is not registered" });
        }
    }
}
//# sourceMappingURL=discovery-command-dispatcher.js.map